/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Control_Track_LabelInputs */



/**
* | output |
* | --- |
* | "AD Control Track" |
*
* @param {Audio_Description_Export_Control_Track_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_control_track_label = /** @type {((inputs?: Audio_Description_Export_Control_Track_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Control_Track_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Piste de contrôle AD")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Steuerspur")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traccia di controllo AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управляющая дорожка АД")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pista de control de AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AD 控制音轨")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AD コントロールトラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD कंट्रोल ट्रैक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faixa de controlo de AD")
	return /** @type {LocalizedString} */ ("AD Control Track")
});